/**
 * UnderwritingTab - the Tab-5 body: sub-section 5a «Antrag» (Slice 13) + sub-section 5b «Underwriting»
 * (P2 Slice 14).
 */

import { AntragSection } from './AntragSection';
import { UnderwritingSection } from './UnderwritingSection';

export function UnderwritingTab({
  placementId,
  canWrite,
  openKind,
  onOpenHandled,
  uwOpenKind,
  onUwOpenHandled,
  onAntragVorbereiten,
}: {
  placementId: string;
  canWrite: boolean;
  openKind?: 'vorbereiten' | 'signatur' | 'einreichen' | null;
  onOpenHandled?: () => void;
  uwOpenKind?: 'annehmen' | 'ablehnen' | null;
  onUwOpenHandled?: () => void;
  onAntragVorbereiten?: () => void;
}) {
  return (
    <div className="flex flex-col gap-6" data-testid="placement-underwriting-tab">
      <AntragSection placementId={placementId} canWrite={canWrite} openKind={openKind} onOpenHandled={onOpenHandled} />
      <UnderwritingSection
        placementId={placementId}
        canWrite={canWrite}
        openKind={uwOpenKind}
        onOpenHandled={onUwOpenHandled}
        onAntragVorbereiten={onAntragVorbereiten}
      />
    </div>
  );
}
